import { faRefresh } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, DatePicker } from "antd"
import dayjs from 'dayjs';
import { useState } from "react";
import { dashboardDatePresets } from "./dashboardModel";

const { RangePicker } = DatePicker;

export type Props = {
  tenantName: string
  dateRange: DateRange
  onRefreshData: (data: any) => void
  showPresets?: boolean
}

export type DateRange = {
  starting: string
  ending: string
}

const DashboardHeroDetails = ({tenantName, dateRange, onRefreshData, showPresets = false}: Props) => {

  const inputRange: any = [dayjs(dateRange?.starting), dayjs(dateRange?.ending)]
  const [range,setRange] = useState<any>(inputRange)

  return  <div className="hero-details">
    <h1>{tenantName}<small>SynkedUP</small></h1>
    <div>
      <RangePicker 
        value={range} 
        presets={showPresets ? dashboardDatePresets(dayjs()) : undefined}
        onChange={(data) => {setRange(data)}}/>
      <Button 
        type="primary"
        style={{marginLeft: '10px'}}
        onClick={() => onRefreshData(range)}>
        <FontAwesomeIcon icon={faRefresh} />
      </Button>
    </div>
  </div>
}

export default DashboardHeroDetails